import { Component, Input, OnInit, inject } from '@angular/core';
import { OktaAuthenticationProvider } from '@lc/core';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lc-app-okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.scss'],
  imports: [MatIcon],
})
export class OktaLoginComponent implements OnInit {
  private oktaAuthService = inject(OktaAuthenticationProvider);
  private router = inject(Router);

  @Input() title: string;

  ngOnInit() {
    if (this.oktaAuthService.getToken()) {
      this.router.navigate(['login', 'callback']);
    } else {
      this.oktaAuthService.login();
    }
  }
}
